export default __webpack_public_path__ + "static/media/arrow-icon.300dab67.svg";